/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'title-header',
	templateUrl: './title-header.component.html',
	styleUrls: ['./title-header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleHeaderComponent {
	@Input() public title: string;
	@Input() public showIcon: boolean;
	@Input() public iconName: string;

	@Output() public closeButtonClicked: EventEmitter<any> = new EventEmitter();

	constructor() {}

	public onClicked(event: unknown) {
		this.closeButtonClicked.emit(event);
	}
}
